//
//
//
//
//
//
//
//
//

import NoResults from '@/components/client/NoResults'
import LazyLoader from '@/components/ui/LazyLoader'
import ClientTasksListItem from '@/components/client/ClientTasksListItem'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ClientTasksList',
  components: {
    LazyLoader,
    ClientTasksListItem,
    NoResults
  },
  props: {
    clientId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      tasks: [],
      loading: false
    }
  },
  async fetch () {
    this.loading = true
    const res = await this.$axios.get(`/clients/${this.clientId}/tasks`)
    this.tasks = res.data.data
    this.loading = false
  }
}
